import React from "react";

const card = "bg-white dark:bg-gray-900 rounded-2xl border border-gray-100 dark:border-gray-800 shadow-sm";
const bar = "rounded-md bg-gray-100 dark:bg-gray-800";

/** Placeholder in the profile's own layout while its data loads. */
const ProfileSkeleton: React.FC = () => (
  <div className="min-h-screen bg-gray-50 dark:bg-gray-950 pt-16" aria-busy="true" aria-label="Profil yüklənir">
    <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 py-6 animate-pulse">
      <div className="grid grid-cols-1 lg:grid-cols-[260px_1fr] gap-4 items-start">
        <div className="space-y-3">
          <div className={`${card} px-6 py-6 flex flex-col items-center gap-3`}>
            <div className="w-24 h-24 rounded-full bg-gray-100 dark:bg-gray-800" />
            <div className={`${bar} h-5 w-36`} />
            <div className={`${bar} h-3 w-24`} />
            <div className={`${bar} h-9 w-full mt-2`} />
          </div>
        </div>
        <div className="space-y-4">
          <div className={`${card} px-6 py-5 space-y-3`}>
            <div className={`${bar} h-3 w-24`} />
            <div className="grid grid-cols-2 gap-2">
              {[0, 1, 2, 3].map(i => <div key={i} className={`${bar} h-10 rounded-xl`} />)}
            </div>
          </div>
          {[0, 1].map(i => (
            <div key={i} className={`${card} px-6 py-5 space-y-3`}>
              <div className={`${bar} h-3 w-32`} />
              <div className={`${bar} h-4 w-full`} />
              <div className={`${bar} h-4 w-5/6`} />
              <div className={`${bar} h-4 w-2/3`} />
            </div>
          ))}
        </div>
      </div>
    </div>
  </div>
);

export default ProfileSkeleton;
